import {
  HAS_NUMBER_REGEX,
  isValidNIF,
  isValidNIE,
  isValidCIF,
  isValidPassport,
  NO_NUMBERS_ERROR,
  REQUIRED_FIELD_ERROR,
  FIELD_INVALID,
} from '@masfront/common-b2c'
import { object, string } from 'yup'

import { Owner } from '~/payments/model/billing.model'

function validateDocIdValue(value: string, isPostpaid: boolean): boolean {
  const postpaidValidation = isValidNIF(value) || isValidNIE(value)
  const prepaidValidation = postpaidValidation || isValidPassport(value)

  const validation = isPostpaid ? postpaidValidation : prepaidValidation

  return !!(value && !isValidCIF(value) && validation)
}

const BillingSchema = (isPostpaid: boolean, docId: string) =>
  object().shape({
    address: string().required(REQUIRED_FIELD_ERROR),
    paymentOwner: object().shape({
      docId: string()
        .label('Documento')
        .when('owner', {
          is: (owner) => owner === Owner.OTHER,
          then: string()
            .required(REQUIRED_FIELD_ERROR)
            .test(
              'isSameAsOwnerDocId',
              'Selecciona el titular como pagador',
              (value) => value !== docId,
            )
            .test('isNifOrNie', FIELD_INVALID, (value) => validateDocIdValue(value, isPostpaid)),
        }),
      name: string()
        .label('nombre')
        .when('owner', {
          is: (owner) => owner === Owner.OTHER,
          then: string().matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR).required(REQUIRED_FIELD_ERROR),
        }),
      firstName: string()
        .label('apellido')
        .when('owner', {
          is: (owner) => owner === Owner.OTHER,
          then: string()
            .matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR)
            .matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR)
            .required(REQUIRED_FIELD_ERROR),
        }),
      lastName: string()
        .label('segundo apellido')
        .when('owner', {
          is: (owner) => owner === Owner.OTHER,
          then: string().matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR).required(REQUIRED_FIELD_ERROR),
          otherwise: string().matches(HAS_NUMBER_REGEX, NO_NUMBERS_ERROR),
        }),
    }),
  })

export default BillingSchema
